export default {
  '布展时间': 'Distribution time',
  '发票开始申请时间': 'Invoice application time',
  '预租时间': 'Pre-lease time',
  '开展时间': 'Development time',
  '参展商报到': 'Exhibitors Report',
  '楣板禁止修改时间': 'No modification time for lintel board',
  '承建商报到': 'Builders check in',
  '撤展时间': 'Withdrawal time',
  '特装审图': 'Online Mapping',
  '展会费用缴纳': 'Site fee payment',
  '租赁服务': 'Rental Services',
  '押金退款': 'Deposit refund',
  '发票申请': 'Invoice application',
  '提交楣板': 'Submit lintel board',
  '提交会刊': 'Submit to the Journal',
  '保险购买': 'Insurance',
  '车证': 'Vehicle license',
  '施工证': 'Construction certificate',
  '展位概况': 'Booth infotmation',
  '此手机号已注册,修改信息失败': 'This mobile phone number has been registered and the modification information failed',

  '特装提交报图资料': 'Submission of drawings for special booth',
  '展位缴纳展会费用入口': 'Entrance for booth to pay exhibition fees',
  '施工证申请入口': 'Construction permit application entrance',
  '展具租赁、用水用电网络': 'Exhibition equipment rental, water and electricity network',
  '展会期间车辆通行证申请': 'Vehicle pass application during the exhibition',
  '申请退还押金入口': 'Entry for deposit refund',
  '申请开具发票入口': 'Application Invoice Entry',
  '提交楣板资料': 'Submit lintel data',
  '提交会刊资料': 'Submission of journal materials',
  '提供展会保险购买服务': 'Provide exhibition insurance purchase service',
  '查看展位详细信息': 'View booth details',

  //租赁类型
  '展具': 'Exhibition tool',
  '用电': 'electric',
  '用气': 'Gas',
  '给水、排水': 'feedwater、drainage',
  '网络、电话': 'network、Telephone',
  '其它': 'other',
  '标摊用电': 'Standard booth electric',
  '椅子': 'Chair',
  '凳子': 'stool',
  '高脚椅': 'High chair',
  '沙发': 'Sofa',
  '办公椅': 'Office chair',
  '扶手椅': 'Armchair',
  '户外座椅': 'Outdoor seats',
  '冰柜': 'Freezer',

  "特装": "Special Booth",
  "标摊": "Standard booth",

  "2": "Special Booth",
  "1": "Standard booth",

  "必缴": "Must pay",
  "非必缴": "Non payment",

  "展会费用": "Exhibition fees",
  "已缴纳": "Paid",
  "存在未缴": "Unpaid",
}



// WEBPACK FOOTER //
// ./src/i18n/en-us/dataI18n/main.js